export default __webpack_public_path__ + "static/media/_testimonial_landingPage.ded67087.png";